import { initAnalytics } from '@mentora/feature-components/analytics'
import { clientEnv } from '@/lib/env'
import { STOREFRONT } from '@/lib/storefront'

initAnalytics(STOREFRONT, clientEnv.NEXT_PUBLIC_POSTHOG_KEY, clientEnv.NEXT_PUBLIC_POSTHOG_HOST)
